import {
  DueOutProcessFlowMetadata,
  DueOutProcessFlowMetadataArgs,
  getDueOutProcessFlowMetadata,
} from '../../assets/ts/data/dueout/dueout-process-flow-metadata'
import useServerData from '../use-server-data'

function useDueoutProcessFlowMetadata(fetchArgs) {
  const {
    data: dueoutProcessFlowMetadata,
    error: dueoutProcessFlowMetadataError,
    fetchData: fetchDueoutProcessFlowMetadata,
    isLoading: dueoutProcessFlowMetadataIsLoading,
  } = useServerData<DueOutProcessFlowMetadata, DueOutProcessFlowMetadataArgs>(
    getDueOutProcessFlowMetadata,
    fetchArgs
  )

  return {
    dueoutProcessFlowMetadata,
    dueoutProcessFlowMetadataError,
    dueoutProcessFlowMetadataIsLoading,
    fetchDueoutProcessFlowMetadata,
  }
}

export default useDueoutProcessFlowMetadata
